import { createContext, useContext } from 'react';

const MockTestContext = createContext({
  active: false,
  currentItem: null,
  currentIndex: 0,
  totalModules: 0,
  completeModule: () => {},
  leaveMockTest: () => {}
});

export const MockTestProvider = MockTestContext.Provider;

export const useMockTest = () => useContext(MockTestContext);
